module.exports = __webpack_public_path__ + "static/img/1680x820.b3b84d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider/1680x820.jpg
// module id = tn5u
// module chunks = 0